export default "__VITE_ASSET__cezALfVY__"